import { useSelector } from "react-redux";
import { AppState } from "store";

export const useAppState = () => useSelector((state: AppState) => state.app);

export const useSelectedStoreIds = () => useAppState().selectedStoreIds;
